
import {useParams} from "react-router-dom";
import useTrackingFetch from "../hooks/useTrackingFetch";
import {Level, ResponseSweetTrackerDto} from "../dto/dto.interface";

import {
    Timeline,
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from '@mui/lab';

//왜 안되는지 모르겠다
// import { HubIcon, LocalShippingIcon, RoofingIcon, ExpandCircleDownIcon } from '@mui/icons-material';
import HubIcon from '@mui/icons-material/Hub';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RoofingIcon from '@mui/icons-material/Roofing';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';

import {Card, Typography} from '@mui/material';

function DeliveryIcon({level: level}: any) {
    return (
        <>
            {
                level == 5 || level == 3 ?
                    <LocalShippingIcon/>
                    :
                    (level == 2 ? <HubIcon/> :
                            level == 6 ? <RoofingIcon/> : <ExpandCircleDownIcon/>
                    )
            }
        </>
    )
}

function DeliveryItem({time, title, desc, level}: any) {

    return (
        <TimelineItem>
            <TimelineOppositeContent
                sx={{m: 'auto 0'}}
                align="right"
                variant="body2"
                color="text.secondary"
            >
                {time}
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineConnector/>
                <TimelineDot color="success">
                    <DeliveryIcon level={level}/>
                </TimelineDot>
                <TimelineConnector/>
            </TimelineSeparator>
            <TimelineContent sx={{py: '12px', px: 2}}>
                <Typography variant="h6" component="span">
                    {title}
                </Typography>
                <Typography>{desc}</Typography>
            </TimelineContent>
        </TimelineItem>
    );
}


export default function Tracking() {

    const {num} = useParams<{ num: string }>();
    const result: ResponseSweetTrackerDto | undefined = useTrackingFetch(num);

    const convertDeliveryStatusText = (level: Level | undefined) => {
        let ret: string = "배송 준비"
        if (level === 1) {
            ret = "배송 준비"
        } else if (level === 2) {
            ret = "집화 완료"
        } else if (level === 3) {
            ret = "배송 진행"
        } else if (level === 4) {
            ret = "지점 도착"
        } else if (level === 5) {
            ret = "배송 출발"
        } else if (level === 6) {
            ret = "배송 완료"
        }
        return ret;
    }

    return (
        <>
            <Card variant="outlined" color="primary">
                운송장 번호: {result?.invoiceNo}
            </Card>
            <Card variant="outlined" color="green">
                배송상태 : {result?.result === 'N' ? "운송장 정보가 없습니다" : convertDeliveryStatusText(result?.level)}
            </Card>
            <Timeline position="alternate">
                {result && result.trackingDetails.map((d: any, index: number) => (
                    <DeliveryItem key={index} time={d.time} title={d.where} desc={d.kind} level={d.level}/>
                ))}
            </Timeline>
        </>
    );
}
